import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-1 text-sm text-green-700 dark:text-green-050" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-neutral2-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-xl leading-6 font-semibold"
}

import Tile from "./Tile.vue";

interface Props {
  back?: boolean;
  pricing?: boolean;
}

interface Emit {
  (event: 'back'): void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BannerHeading',
  props: {
    back: { type: Boolean },
    pricing: { type: Boolean }
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, {
    "big-space": "",
    class: "tile-highlight-long dark:tile-highlight"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _cache[1] || (_cache[1] = _createTextVNode(" 4programmers ")),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back'))),
          class: "cursor-pointer"
        }, " » Praca "),
        (props.back)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " » Ogłoszenie "))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.pricing)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " Znajdź najlepszych programistów szybciej i skuteczniej! "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-xl leading-6 font-semibold" }, [
                _createElementVNode("h1", { class: "max-md:hidden" }, " Oferty Pracy w IT - Odwiedza nas ponad 150 tys. programistów miesięcznie "),
                _createElementVNode("h1", { class: "md:hidden mb-1" }, " Oferty Pracy w IT ")
              ], -1 /* CACHED */)),
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "md:hidden" }, " Odwiedza nas ponad 150 tys. programistów miesięcznie ", -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})